import { render, staticRenderFns } from "./updatereservation.vue?vue&type=template&id=28b1eecd&"
import script from "./updatereservation.vue?vue&type=script&lang=js&"
export * from "./updatereservation.vue?vue&type=script&lang=js&"
import style0 from "./updatereservation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports